import { ref } from 'vue';

const estimatedMaintenanceCompletionTime = ref(import.meta.env.MIX_MAINTENANCE_ESTIMATED_COMPLETION_TIME || null);

export function useEstimatedMaintenanceCompletionTime(): null | string {
    if (!estimatedMaintenanceCompletionTime.value) {
        return null;
    }

    const now = new Date();
    const estimatedMaintenanceCompletionDate = new Date(estimatedMaintenanceCompletionTime.value);

    if (Number.isNaN(estimatedMaintenanceCompletionDate.getTime()) || estimatedMaintenanceCompletionDate < now) {
        return null;
    }

    return estimatedMaintenanceCompletionDate.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
    });
}
